module.exports = __webpack_public_path__ + "static/media/preview3-small.42f4c130.jpg";